import { LocalAudioTrack } from 'twilio-video';
import { useCallback } from 'react';
import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useParticipantsAudioToggle() {
  const { room: {localParticipant},localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  
  let isEnabled = true;

  const toggleParticipantsAudio = useCallback((props: any, muteUnmuteStatus:any, participants: any) => {
    let {room} = props
    let {activeRoom} = room
    //let {participants} = activeRoom
    isEnabled = !isEnabled
    let activeCalls = props.activeCalls.map((item: any) => {
     return item.mobileNumber
    })

    for(let i of participants){
      if(!activeCalls.includes(i.identity)){
        activeCalls.push(i.identity)
      }
    }
    
    let participantIds = participants.map((item: any) => {
     return item.identity
    })

    
    props.muteUnmuteAllParticipants(activeCalls, isEnabled)
    muteUnmuteStatus(isEnabled)
  }, [audioTrack]);


  return [isEnabled, toggleParticipantsAudio] as const;
}
